// Import required Firebase modules
import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDxiFAYbqxHYEYpjcrMNKphbMVigm3MfY0",
  authDomain: "ffl-website-410406.firebaseapp.com",
  projectId: "ffl-website-410406",
  storageBucket: "ffl-website-410406.appspot.com", // ⚠️ Corrected storageBucket domain
  messagingSenderId: "1087753627386",
  appId: "1:1087753627386:web:afe59f348edd8f27758b43",
  measurementId: "G-HXMNJVWVYT",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)

export { auth, db } // ✅ Use named exports
export default app
